import "./OurJourney.module.css";
import Header from "@/reusable_sections/Header";
import WaitingForBaby from "./sections/WaitingForBaby";
import TheStorySoFar from "./sections/TheStorySoFar";
import JoinTheCelebration from "./sections/JoinTheCelebration";
import Footer from "@/reusable_sections/Footer";
export default function OurJourneyPage() {
  return <div>
      <Header />
      <WaitingForBaby />
      <TheStorySoFar />
      <JoinTheCelebration />
      <Footer />
    </div>;
}